import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_40000621_55242)">
        <path
          d="M3.33325 8.33332C3.33325 8.77535 3.50885 9.19927 3.82141 9.51183C4.13397 9.82439 4.55789 9.99999 4.99992 9.99999C5.44195 9.99999 5.86587 9.82439 6.17843 9.51183C6.49099 9.19927 6.66659 8.77535 6.66659 8.33332C6.66659 7.8913 6.49099 7.46737 6.17843 7.15481C5.86587 6.84225 5.44195 6.66666 4.99992 6.66666C4.55789 6.66666 4.13397 6.84225 3.82141 7.15481C3.50885 7.46737 3.33325 7.8913 3.33325 8.33332Z"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 3.33334V6.66668"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 10V16.6667"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.33325 13.3333C8.33325 13.7754 8.50885 14.1993 8.82141 14.5118C9.13397 14.8244 9.55789 15 9.99992 15C10.4419 15 10.8659 14.8244 11.1784 14.5118C11.491 14.1993 11.6666 13.7754 11.6666 13.3333C11.6666 12.8913 11.491 12.4674 11.1784 12.1548C10.8659 11.8423 10.4419 11.6667 9.99992 11.6667C9.55789 11.6667 9.13397 11.8423 8.82141 12.1548C8.50885 12.4674 8.33325 12.8913 8.33325 13.3333Z"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 3.33334V11.6667"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 15V16.6667"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 5.83332C13.3333 6.27535 13.5088 6.69927 13.8214 7.01183C14.134 7.32439 14.5579 7.49999 14.9999 7.49999C15.4419 7.49999 15.8659 7.32439 16.1784 7.01183C16.491 6.69927 16.6666 6.27535 16.6666 5.83332C16.6666 5.3913 16.491 4.96737 16.1784 4.65481C15.8659 4.34225 15.4419 4.16666 14.9999 4.16666C14.5579 4.16666 14.134 4.34225 13.8214 4.65481C13.5088 4.96737 13.3333 5.3913 13.3333 5.83332Z"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 3.33334V4.16668"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 7.5V16.6667"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_40000621_55242">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
